import { msg, t } from "@lingui/core/macro"
import { useParams } from "react-router-dom"
import { CAUTION_PASSWORD } from "../constants"
import { Inbox } from "../Inbox/Inbox"
import { MessageList } from "../MessageList/MessageList"
import styles from "./UnifiedChat.module.scss"

const NO_MESSAGE_SELECTED = msg`Please select a conversation to start or send a new message.`

export const UnifiedChat: React.FC = () => {
    const { username } = useParams<{ username: string }>()

    return (
        <div className={styles.container}>
            <Inbox onClose={() => {}} />

            <div className={styles.verticalLine} />

            {username ? (
                <MessageList onClose={() => {}} isMinimized={false} />
            ) : (
                <div className={styles.emptyText}>
                    <h1>{t(NO_MESSAGE_SELECTED)}</h1>
                    <h2>{t(CAUTION_PASSWORD)}</h2>
                </div>
            )}
        </div>
    )
}
